import { Middleware } from "redux";
import { RefsixState } from "../models/refsixState";
import { SET_USER_ACTIONS_CHECKLIST, SHOW_ONBOARDING_FLOW } from "../actions/types";
import { updateUserActionsCheckListInDB } from "../../services/userActionsCheckListService";
import _ from "lodash";
import { UserActionsCheckList } from "refsix-js-models";
import { trackUserActionsCheckListUpdated } from "../../services/analytics/analyticsService";
import { setUserActionsCheckList } from "../actions/userActionsCheckList";
import { setUserActionsCheckListWriteInProgress } from "../actions/appStatus";

export const userActionsCheckListMiddleware: Middleware<{}, RefsixState> =
    (store) => (next) => (action) => {
        switch (action.type) {
            case SHOW_ONBOARDING_FLOW:
                if (!action.value) {
                    store.dispatch(
                        setUserActionsCheckList({
                            onboardingCompleted: true,
                        })
                    );
                }
                break;
            case SET_USER_ACTIONS_CHECKLIST:
                const oldUserActionsCheckList =
                    store.getState().userActionsCheckList;
                const newUserActionsCheckList = action.userActionsCheckList;

                // Send the updated values to analytics platforms
                let propertiesChanged = {};
                if (oldUserActionsCheckList) {
                    const oldUserActionsCheckListObject =
                        oldUserActionsCheckList as UserActionsCheckList;
                    // use loadash to filter out the properties that did not change
                    propertiesChanged = _.omitBy(
                        newUserActionsCheckList,
                        (value: any, key) => {
                            return _.isEqual(
                                value,
                                oldUserActionsCheckListObject[key]
                            );
                        }
                    );
                } else {
                    propertiesChanged = newUserActionsCheckList;
                }

                if (Object.keys(propertiesChanged).length > 0) {
                    // Create merged state to write to DB (not just the partial update)
                    const mergedUserActionsCheckList = {
                        ...oldUserActionsCheckList,
                        ...newUserActionsCheckList,
                    };

                    // Set write-in-progress flag to prevent immediate overwrites from DB sync
                    store.dispatch(setUserActionsCheckListWriteInProgress(true));

                    // Update the userActionsCheckList in the database with merged state
                    updateUserActionsCheckListInDB(mergedUserActionsCheckList)
                        .then(() => {
                            // Clear flag after short delay to allow DB changes to propagate
                            setTimeout(() => {
                                store.dispatch(setUserActionsCheckListWriteInProgress(false));
                            }, 200);
                        })
                        .catch((err) => {
                            console.log(
                                "Error updating user actions checklist in DB: ",
                                err
                            );
                            // Clear flag even on error
                            store.dispatch(setUserActionsCheckListWriteInProgress(false));
                        });

                    // only track if there are changes
                    trackUserActionsCheckListUpdated(propertiesChanged);
                }

                break;
        }

        next(action);
    };
